import LockerType from 'src/models/locker/LockerType'
import DurationPeriod from 'src/models/period/DurationPeriod'
import DurationString from 'src/models/period/DurationString'
import Rental from 'src/models/rental/Rental'
import RentalBasedProduct from 'src/models/order/product/RentalBasedProduct'
import RentalRequestJson from 'src/models/order/interfaces/RentalRequestJson'

export default class RentalRequest extends RentalBasedProduct {
  static readonly PRODUCT_TYPE = 'rental'

  readonly lockerType: LockerType
  readonly durationPeriod: DurationPeriod
  readonly durationString: DurationString

  constructor(
    lockerType: LockerType,
    durationPeriod: DurationPeriod,
    durationString: DurationString,
    rental: Rental | null,
  ) {
    super(RentalRequest.PRODUCT_TYPE, rental)
    this.lockerType = lockerType
    this.durationPeriod = durationPeriod
    this.durationString = durationString
  }

  static fromJson(data: RentalRequestJson) {
    return new this(
      LockerType.fromJson(data.lockerType),
      DurationPeriod.fromJson(data.durationPeriod),
      DurationString.fromJson(data.durationString),
      data.rental ? Rental.fromJson(data.rental) : null,
    )
  }

  toJson(): RentalRequestJson {
    return {
      productType: this.productType,
      lockerType: this.lockerType.toJson(),
      durationPeriod: this.durationPeriod.toJson(),
      durationString: this.durationString,
      rental: this.rental ? this.rental.toJson() : null,
    }
  }
}
